module.exports = {"StatusCode":200,"Payload":[{"SecretString":"$some-$secret-$key"}]}


//////////////////
// WEBPACK FOOTER
// ./src/payloads/aws/lambda/mocks/getSecretKey.json
// module id = aRcY
// module chunks = 0